




























import Vue from "vue"
export default Vue.extend({
  name: "progressbarover",

  props:{
    isvisible:Boolean
  },

})
